import { DataTable, Menu, Tab, Tabs } from "grommet";
import { Refresh } from "grommet-icons";
import React, { useEffect, useState } from "react";
import MedicalEmergencyService from "../../../../../services/medical-emergency/medical-emergency.service";
import { IMedicalEmergencyApiResponse } from "../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";
import StandardColors from "../../../../../util/StandardColors";
import RightSidebar from "../../common/right-sidebar/RightSidebar";
import useLongPress from "../../common/util/LongPress";
import { EmsColumns } from "./components/columns/ems/EmsColumns";
import { MedicalEmergencyColumns } from "./components/columns/medical-emergency/MedicalEmergencyColumns";
import Style from "./Coordinator.module.css";
import { CoordinatorService } from "./CoordinatorService";
import { observer } from "mobx-react";
import { useStore } from "../../../../../Hooks/useStore";


function CoordinatorHome() {
  const { rootStore } = useStore();
  const [medicalEmergencyList, setMedicalEmergencyList] = useState<
    IMedicalEmergencyApiResponse[]
  >([]);

  const [selectedMedicalEmergencyList, setSelectedMedicalEmergencyList] =
    useState<(string | number)[]>([]);

  const [selectionActivated, setSelectionActivated] = useState(false);

  const [showRightSidebar, setShowRightSidebar] = useState(false);

  const [emsUsers, setEmsUsers] = useState<
    {
      id: string;
      name: string;
    }[]
  >([]);

  useEffect(() => {
    refreshMedicalEmergencyList();
  }, []);

  const refreshMedicalEmergencyList = () => {
    MedicalEmergencyService.listMedicalEmergencies().then(
      setMedicalEmergencyList
    );
  };

  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 500,
  };

  const longPressEvent = useLongPress(
    () => {
      setSelectionActivated(true);
    },
    () => {},
    defaultOptions
  );

  const assignToEms = () => {
    CoordinatorService.listEmsUser().then(setEmsUsers);
    setShowRightSidebar(true);
  };

  const submitAssignEms = (selectedUsers: (string | number)[]) => {
    if (selectedUsers.length > 1) {
      alert("Please select only one User.");
      return;
    }
    if (selectedUsers.length === 0) {
      alert("Please select atleast one User.");
      return;
    }
    const promises: Promise<any>[] = [];
    selectedMedicalEmergencyList.forEach((emergencyId) => {
      promises.push(
        CoordinatorService.assignEms(selectedUsers[0], emergencyId)
      );
    });
    Promise.all(promises)
      .then(() => {
        rootStore.notificationToastStore.showNotification("Assignment Successful",false, 3000);
        refreshMedicalEmergencyList();
      })
      .catch((e) => {
        console.log("error", e);
        alert(
          "Failed to assign " +
            (selectedMedicalEmergencyList.length > 1
              ? "emergencies"
              : "emergency")
        );
      });
  };

  const pendingAssignmentMedicalEmergencyList = medicalEmergencyList.filter(
    (emergency) =>
      emergency.assignedEms === "" ||
      emergency.assignedEms === undefined ||
      emergency.assignedEms === null
  );


  return (
    <div>
      <div className={Style.hintContainer}>
        <div />
        <p className={Style.hintText}>Long click on the row to select items.</p>
        <Refresh
          color={StandardColors.primary_blue_100}
          onClick={refreshMedicalEmergencyList}
          className={Style.icon}
        />
      </div>

      {selectedMedicalEmergencyList.length > 0 ? (
        <div className={Style.menuContainer}>
          <Menu
            label="Actions"
            items={[
              [
                {
                  label: "Assign to EMS",
                  onClick: assignToEms,
                },
              ],
            ]}
          />
        </div>
      ) : (
        <></>
      )}
      <Tabs alignControls="start">
        <Tab title="Pending Assignment">
          {pendingAssignmentMedicalEmergencyList.length != 0 ? (
            <DataTable
              border={"all"}
              className={Style.tableContainer}
              background={{
                header: { color: "brand-1" },
              }}
              columns={MedicalEmergencyColumns}
              data={pendingAssignmentMedicalEmergencyList}
              resizeable
              step={8}
              sortable
              paginate
              {...longPressEvent}
              {...(!selectionActivated
                ? {
                    onClickRow: (event) => {},
                  }
                : {})}
              {...(selectionActivated
                ? {
                    select: selectedMedicalEmergencyList,
                    onSelect: (items) => {
                      if (items.length === 0) setSelectionActivated(false);
                      setSelectedMedicalEmergencyList(items);
                    },
                  }
                : {})}
            />
          ) : (
            <div className={Style.allAssignedTextContainer}>
              <p className={Style.allAssignedText}>
                All Medical Emergencies are assigned.
              </p>
            </div>
          )}
        </Tab>
        <Tab title="Assigned">
          <DataTable
            border={"all"}
            className={Style.tableContainer}
            background={{
              header: { color: "brand-1" },
            }}
            columns={MedicalEmergencyColumns}
            data={medicalEmergencyList}
            resizeable
            step={8}
            sortable
            paginate
            {...longPressEvent}
            {...(!selectionActivated
              ? {
                  onClickRow: (event) => {},
                }
              : {})}
            {...(selectionActivated
              ? {
                  select: selectedMedicalEmergencyList,
                  onSelect: (items) => {
                    if (items.length === 0) setSelectionActivated(false);
                    setSelectedMedicalEmergencyList(items);
                  },
                }
              : {})}
          />
        </Tab>
      </Tabs>
    
      

      {showRightSidebar ? (
        <RightSidebar
          title="Assign EMS Provider"
          tableTitle="EMS Provider"
          submitButtonTitle="Assign"
          onSubmit={submitAssignEms}
          description="Please select the EMS user to whom you want to assign the medical emergency."
          onCancel={() => setShowRightSidebar(false)}
          tableData={emsUsers}
          columns={EmsColumns}
          showSubmitButton={true}
        />
      ) : (
        <></>
      )}
    </div>
    
  );
}

export default observer(CoordinatorHome);
